import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * FICHA RÁPIDA DE LA LIQUIDACIÓN (Mario, 12-oct; FIC-03): cualquier pantalla abre el panel con `abrir('LIQ-…')`. El panel
 * vive una sola vez en la consola (en la barra), así no se repite en cada pantalla.
 */
@Injectable({ providedIn: 'root' })
export class FichaLiquidacionService {
  readonly codigo$ = new BehaviorSubject<string | null>(null);
  abrir = (code: string | null | undefined): void => { if (code) this.codigo$.next(String(code)); };
  cerrar = (): void => this.codigo$.next(null);
}
